import { useEffect } from 'react';
import type { UseUnmountEffect } from './types';

const useUnmountEffect: UseUnmountEffect = (callback, deps = []) =>
  useEffect(
    () => () => callback(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );

export default useUnmountEffect;
